export default __webpack_public_path__ + "static/media/vortex.732ed8dd.svg";